// Áreas que capturan resultados semanales. `id` se usa en el menú de Carga de Datos.
export const AREAS = [
  { id: "ventas", nombre: "Ventas", color: "#2563eb" },
  { id: "rh", nombre: "RH", color: "#16a34a" },
  { id: "ingenieria", nombre: "Ingeniería", color: "#dc2626" },
];

export const SEMANAS = ["semana1", "semana2", "semana3", "semana4"];

export const META_MENSUAL = 1000000;

const STORAGE_KEY = "datosFinancieros";

export const obtenerNombreMes = () =>
  new Date().toLocaleDateString("es-MX", { month: "long", year: "numeric" });

export const totalRegistro = (registro) =>
  SEMANAS.reduce((acc, semana) => acc + (Number(registro[semana]) || 0), 0);

export const leerRegistros = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const buscarRegistro = (area, mes) =>
  leerRegistros().find((item) => item.area === area && item.mes === mes);

export const guardarRegistro = (registro) => {
  const registros = leerRegistros();
  const indice = registros.findIndex(
    (item) => item.area === registro.area && item.mes === registro.mes
  );

  if (indice >= 0) {
    registros[indice] = registro;
  } else {
    registros.push(registro);
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(registros));
};
